import { hydrateKnowledgeFactSources } from './knowledgeFactSourceAttribution';
import {
  collection,
  onSnapshot,
  query,
  where,
} from 'firebase/firestore';
import { db } from '../../services/firebase';
import { KNOWLEDGE_ITEMS_COLLECTION } from './knowledgeItemModel';
import { normalizeKnowledgeFact } from './knowledgeFactNormalizer';

export const subscribeToKnowledgeFacts = ({
  childId = '',
  onFacts = () => {},
  onError = () => {},
} = {}, deps = {}) => {
  const cleanChildId = String(childId || '').trim();
  if (!cleanChildId) {
    onFacts([]);
    return () => {};
  }

  const firestoreDb = deps.db || db;
  const collectionFn = deps.collection || collection;
  const queryFn = deps.query || query;
  const whereFn = deps.where || where;
  const snapshotFn = deps.onSnapshot || onSnapshot;
  const factsQuery = queryFn(
    collectionFn(firestoreDb, KNOWLEDGE_ITEMS_COLLECTION),
    whereFn('childId', '==', cleanChildId)
  );

  let active = true;
  let revision = 0;
  const unsubscribe = snapshotFn(
    factsQuery,
    (snapshot) => {
      const currentRevision = ++revision;
      const facts = snapshot.docs.map((factDoc) => normalizeKnowledgeFact({
        id: factDoc.id,
        ...factDoc.data(),
      }));
      onFacts(facts);
      if (facts.some(fact => (fact.reviewedBy && !fact.reviewedByName) || fact.sourceRefs.some(ref => ref.confirmedBy || (ref.sourceCollection === 'careSources' && (!ref.authorName || !ref.capturedAt))))) {
        hydrateKnowledgeFactSources(facts, deps.getCareSourceById).then(hydrated => {
          if (active && currentRevision === revision) onFacts(hydrated);
        });
      }
    },
    (error) => { revision += 1; onError(error); }
  );
  return () => { active = false; unsubscribe(); };
};
